import { ISidebarNavigation } from "@/api/types/helpers/types";
import {
  Activity,
  Grid2X2,
  Home,
  LayoutList,
  MessagesSquare,
  Package,
  RussianRuble,
  ScanSearch,
  Store,
  Truck,
  Users,
} from "lucide-react";

export const sidebarNavigation: ISidebarNavigation = {
  main: [
    {
      groupName: "Отдел продукта",
      department: "PRODUCT",
      menuItems: [
        {
          label: "Отзывы",
          role: "all",
          icon: Home,
          path: "/services/review",
        },
      ],
    },
    {
      groupName: "Коммерция",
      department: "COMMERS",
      menuItems: [
        {
          label: "Дашборд",
          role: "all",
          icon: Activity,
          path: "/commers/dashboard",
        },
        {
          label: "Таблица",
          role: "all",
          icon: LayoutList,
          path: "/commers/table",
        },
        {
          label: "Остатки",
          role: "all",
          icon: Package,
          path: "/commers/stock",
        },
        {
          label: "Заказы",
          role: "all",
          icon: Truck,
          path: "/commers/orders",
        },
        {
          label: "Прибыль",
          role: "all",
          icon: RussianRuble,
          path: "/commers/profit",
        },
        {
          label: "Ключевые слова",
          role: "all",
          icon: Home,
          path: "/commers/recommended-keywords",
        },
      ],
    },
    {
      groupName: "Аналитика",
      department: "ANALYTIC",
      menuItems: [
        {
          label: "Дашборд",
          role: "all",
          icon: Home,
          path: "/dashboard5",
        },
      ],
    },
    {
      groupName: "Админ",
      department: "FATHERS",
      menuItems: [
        {
          label: "Меню",
          role: "all",
          icon: Home,
          path: "admin/menu",
        },
      ],
    },
  ],
  services: [
    {
      groupName: "Сервисы",
      menuItems: [
        {
          label: "Отзывы",
          role: "all",
          icon: Home,
          path: "/services/review",
        },
        {
          label: "Категории",
          role: "all",
          icon: Grid2X2,
          path: "/services/categories",
        },
        {
          label: "Конкуренты WB",
          role: "all",
          icon: ScanSearch,
          path: "/services/competitors",
        },
        {
          label: "Каналы продаж",
          role: "all",
          icon: Store,
          path: "/services/sale-channels",
        },
      ],
    },
  ],
  secondary: [
    {
      groupName: "Меню",
      menuItems: [
        {
          label: "Сотрудники",
          role: ["BOSS", "CEO", "DEVELOPER", "DREADNOUGHT"],
          icon: Users,
          path: "/users",
        },
        {
          label: "Поддержка",
          role: "all",
          icon: MessagesSquare,
          path: "/support",
        },
      ],
    },
  ],
};
